import { Tooltip } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import AddMemberToSample from '@components/assign-team-member/AddMemberToSample';
import CustomDropdown from '@components/CustomDropdown';
import ModalContainer from '@components/modals/ModalContainer';
import NoData from '@components/NoData';
import SampleComment from '@components/SampleComment';
import { toastError, toastSuccess } from '@components/Toast';
import TopDetails from '@components/TopDetails';

import useWindowSize from '@hooks/useWindowSize';

import { allFilterPages, sampleDetailsFilterFields } from '@features/filter/static/filterUtil';
import SampleDetailsTopHeader from '@features/filter/v2/core/Sample/SampleDetailsTopHeader';
import FilterComponent from '@features/filter/v2/FilterComponent';
import RequestTimeline from '@features/sampleDevelopment/components/RequestTimeline';
import SampleActionPopup from '@features/sampleDevelopment/components/SampleActionPopup';
import SampleDesignCard from '@features/sampleDevelopment/components/SampleDesignCard';
import SampleInlineComment from '@features/sampleDevelopment/components/SampleInlineComment';

import { clearCurrentActivePage, setCurrentActivePage } from '@store/actions/ActivePageAction';
import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { fetchSupplierByMaterialType } from '@services/supplierService';

import ApiClient from '@lib/apiClient';

import {
	_getKey,
	changeDateFormat,
	checkPrimaryUserType,
	checkSingular,
	getActionDoneBy,
	getColorWiseActivityStatusOfSample,
	getShortName,
	getUserInfo,
	renderDesignDetails,
	renderFabricColorAndSizeColumn,
	renderMaterialsList,
	STATIC_SET_CONSTANTS
} from '@utils/Util';

import { BASE_URL, LIST_VIEW_TYPE } from '@/constants/constant';

const SampleRequestCard = ({
	sampleData,
	cardType,
	sampleRequestId,
	fetchDevelopmentList,
	handleAllCheckboxOfParent,
	handleCheckboxOfParent,
	selectedDesignIdsOfParent
}) => {
	const [activeRemarksId, setActiveRemarksId] = useState(null);
	const [showComment, setShowComment] = useState(false);
	const [selectedId, setSelectedId] = useState(null);
	const [selectedRow, setSelectedRow] = useState(null);
	const [countryList, setCountryList] = useState([]);
	const [sample, setSample] = useState(null);
	const [selectedIds, setSelectedIds] = useState([]);
	const [supplierList, setSupplierList] = useState([]);
	const [isUpdateClick, setIsUpdateClick] = useState(false);
	const [isShowFilter, setIsShowFilter] = useState(true);
	const [defaultViewType, setDefaultViewType] = useState(
		getUserInfo().systemPreference?.sampleDetailsViewType
	);
	const [showSampleTimelineId, setShowSampleTimelineId] = useState(null);
	const isLoading = useSelector((store) => store.loaderStore);
	const dispatch = useDispatch();
	const { id } = useParams();
	const navigate = useNavigate();
	const elementRef = useRef(null);
	const [selectedSampleItemId, setSelectedSampleItemId] = useState(null);
	useWindowSize(() => setIsShowFilter(false));
	const location = useLocation();

	useEffect(() => {
		let searchParams = new URLSearchParams(location.search);
		let isShowComment = searchParams.get('showComment');
		let productId = searchParams.get('productId');
		let selectedSample = searchParams.get('selectedSample');
		if (selectedSample) {
			setSelectedSampleItemId(selectedSample);
		}
		if (isShowComment && productId) {
			setSelectedId(productId);
		}
	}, [location.search]);

	useEffect(() => {
		setSample(sampleData);
	}, [sampleData]);

	const onFetchSupplierList = async (value) => {
		try {
			dispatch(openLoader());
			let response = await fetchSupplierByMaterialType(value);
			response = response?.data?.map((item) => {
				return {
					id: item.id,
					value: item.name
				};
			});
			setSupplierList(response);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const fetchCountryList = () => {
		// dispatch(openLoader());
		ApiClient.GET('getCountryListByUnits', 'SAMPLE_HOUSE')
			.then(({ data }) => {
				let lists = [];
				data.map((item) => lists.push({ id: item.id, value: item.name }));
				setCountryList(lists);
				// dispatch(closeLoader());
			})
			.catch(() => {
				dispatch(closeLoader());
				toastError('Unable to fetch Country list!');
			});
	};

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const isShowComment = params.get('showComment');
		fetchCountryList();
		if (isShowComment) {
			setShowComment(true);
		}
		return () => {
			dispatch(clearCurrentActivePage());
		};
	}, []);

	const getSetMembersIds = (setItem = []) => {
		const membersList =
			(setItem?.setMemberSampleRequestItemResponseList &&
				setItem?.setMemberSampleRequestItemResponseList?.map((member) => member.id)) ||
			[];
		return membersList;
	};

	const handleDropDown = (obj, type) => {
		let updatedSelectedRow = {
			...selectedRow,
			[type]: { id: obj.id, name: obj.value }
		};

		if (type === 'developmentFactory' && selectedRow?.fabricType === 'KNIT') {
			updatedSelectedRow = {
				...updatedSelectedRow,
				fabricSupplier: { id: obj.id, name: obj.value }
			};
		}
		if (type === 'unitResponse') {
			updatedSelectedRow = {
				...updatedSelectedRow,
				fabricSupplier: null,
				developmentFactory: null
			};
		}
		setSelectedRow(updatedSelectedRow);
	};

	const onClearChat = () => {
		setSample((prevQuoteStore) => ({
			...prevQuoteStore,
			sampleRequestItemResponseList: prevQuoteStore?.sampleRequestItemResponseList?.map((item) => {
				if (item.productId === selectedId) {
					return {
						...item,
						noOfUnreadMessage: 0
					};
				}
				return item;
			})
		}));

		setSelectedId(null);
	};

	const onChangeSubmissionDate = (e, selectedItem) => {
		let inputValue = e.target.value;
		setSelectedRow({ ...selectedRow, submissionPlanDate: inputValue });
		setSample((prev) => ({
			...prev,
			sampleRequestItemResponseList: prev.sampleRequestItemResponseList.map((item) => {
				if (item.id === selectedItem.id) {
					return {
						...item,
						submissionPlanDate: inputValue
					};
				}
				return item;
			})
		}));
		handleSubmit({ ...selectedRow, submissionPlanDate: inputValue });
	};

	const handleSubmit = (data) => {
		const ids = getSetMembersIds(data);
		dispatch(openLoader());
		let postData = {
			id: data?.isSetMember ? data.setParentId : data.id,
			operationalUnitId: data?.unitResponse?.id,
			developmentFactoryId: data?.developmentFactory?.id || null,
			fabricSupplierId: data?.fabricSupplier?.id || null,
			setMemberIdList: ids,
			submissionPlanDate: data?.submissionPlanDate,
			isSet: data.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT
		};
		ApiClient.PUT(`${BASE_URL}/sample/request/${sampleRequestId}/items`, postData, '', true)
			.then(({ data }) => {
				toastSuccess(data.message);
				setSelectedRow(null);
				setIsUpdateClick(false);
				fetchDevelopmentList();
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	const handleCommentClose = () => {
		dispatch(clearCurrentActivePage());
		setShowComment(false);
		onClearChat();
	};

	const isSetItem = (design) => {
		return design?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT || design.isSet;
	};

	const openDesignViewModal = (selectedDesign) => {
		dispatch(
			setDesignViewModalInfo({
				mergeProductList: isSetItem(selectedDesign)
					? selectedDesign.setMemberSampleRequestItemResponseList.map((item) => item?.productId)
					: [],
				isShowMergeTechPack: isSetItem(selectedDesign),
				id: selectedDesign?.productId,
				onCloseViewModal: () => {
					dispatch(clearDesignViewModalInfo({}));
				},
				onUpdateCostingStatus: () => false,
				updateProductStatus: () => false,
				source: 'PRODUCT_LIST'
			})
		);
	};

	const renderDevelopmentDetails = (developmentDetails) => {
		return (
			<div className="sample-status-with-details">
				<div className="d-flex align-items-center">
					<p className="regular-14 weight-300 gray_dark_02">Country In-house/Factory: </p>
					<Tooltip
						title={<span className="regular-14">{developmentDetails?.unitResponse?.name}</span>}
						placement="top"
						arrow
					>
						<span className="gray_dark_01 ml-1">
							{getShortName(developmentDetails?.unitResponse?.name, 12)}
						</span>
					</Tooltip>
				</div>

				<div className="d-flex align-items-center">
					<p className="regular-14 weight-300 gray_dark_02">Development Factory: </p>
					<Tooltip
						title={
							<span className="regular-14">{developmentDetails?.developmentFactory?.name}</span>
						}
						placement="top"
						arrow
					>
						<span className="gray_dark_01 ml-1">
							{' '}
							{getShortName(developmentDetails?.developmentFactory?.name, 17)}
						</span>
					</Tooltip>
				</div>

				<div className="d-flex align-items-center">
					<p className="regular-14 weight-300 gray_dark_02">Fabric Supplier: </p>
					<Tooltip
						title={<span className="regular-14">{developmentDetails?.fabricSupplier?.name}</span>}
						placement="top"
						arrow
					>
						<span className="gray_dark_01 ml-1">
							{getShortName(developmentDetails?.fabricSupplier?.name, 23)}
						</span>
					</Tooltip>
				</div>

				<button
					className="button text-only"
					onClick={() => {
						onFetchSupplierList();
						setSelectedRow(developmentDetails);
						setIsUpdateClick(true);
					}}
					disabled={cardType === 'DEVELOPMENT' && !checkPrimaryUserType('FASHION_DESIGNER')}
				>
					<span className="blue weight-500">Update</span>
				</button>
			</div>
		);
	};

	const renderSatusColumn = (statusDetails) => {
		return (
			<div className={`sample-status-with-details ${showSampleTimelineId ? 'timeline-opened' : ''}`}>
				<div className="sample-status">
					{getColorWiseActivityStatusOfSample(
						statusDetails?.currentActivity?.activityType === 'REQUESTED'
							? 'SAMPLE_REQUESTED'
							: statusDetails?.currentActivity?.activityType,
						getActionDoneBy(statusDetails?.currentActivity?.userType || null)
					)}
					{statusDetails.basePrice && (
						<p className="costing-amount regular-14">
							${statusDetails.basePrice?.toFixed(2)} <span>/unit</span>
						</p>
					)}
					{statusDetails?.consumptionResponse &&
						statusDetails.consumptionResponse.map((res) => (
							<ul className="common-list-component" key={_getKey()}>
								<li>
									{res.quantity}
									{res.quantityUnit}
								</li>
							</ul>
						))}
				</div>
				<p>{changeDateFormat(statusDetails?.currentActivity?.createdAt, '', 'Do MMM, YYYY')}</p>
				{statusDetails.id === showSampleTimelineId && (
					<RequestTimeline
						requireDate={statusDetails?.requireDate}
						currentActivity={statusDetails?.currentActivity?.activityType || null}
						activityList={statusDetails.timeLineActivityResponse}
						onCloseTimeline={(e) => {
							e?.stopPropagation();
							setShowSampleTimelineId(null);
						}}
					/>
				)}
			</div>
		);
	};

	const renderSetItemRow = (membersOfSet = [], sampleRequestId) => {
		if (membersOfSet.length > 1) {
			const skipOneSetmember = membersOfSet?.slice(1);
			return (
				<>
					{skipOneSetmember?.map((member) => (
						<tr
							key={`set-members${member.id}`}
							className={
								sampleRequestId && selectedSampleItemId == sampleRequestId
									? 'highlight-table-row'
									: ''
							}
						>
							<td className="materials-list-column">
								{renderMaterialsList(member.materialList && member.materialList)}
							</td>
							<td>
								<div className="sample-details">
									{member.sampleItemDetailsResponseList &&
										member.sampleItemDetailsResponseList.length > 0 &&
										member.sampleItemDetailsResponseList.map((color) =>
											renderFabricColorAndSizeColumn(color)
										)}
								</div>
							</td>
						</tr>
					))}
				</>
			);
		}
	};
	const getTotalDesignsCount = () => sample?.sampleRequestItemResponseList?.length === selectedIds?.length;

	const handleSelectAll = (e) => {
		if (e.target.checked) {
			setSelectedIds(sample?.sampleRequestItemResponseList);
		} else setSelectedIds([]);
	};

	const renderAllCheckBox = () => {
		return cardType !== 'DEVELOPMENT' ? (
			<div className="custom-chekbox">
				<div className="form-group m-0">
					<input
						type="checkbox"
						name="Company"
						id="sampleAllSelect"
						checked={getTotalDesignsCount()}
						onChange={handleSelectAll}
					/>
					<label htmlFor="sampleAllSelect"></label>
				</div>
			</div>
		) : (
			<div className="custom-chekbox">
				<div className="form-group m-0">
					<input
						type="checkbox"
						name="sampleAllSelect"
						id="sampleAllSelect"
						checked={
							sample?.sampleRequestItemResponseList?.length ===
							selectedDesignIdsOfParent?.length
						}
						onChange={handleAllCheckboxOfParent}
					/>
					<label htmlFor="sampleAllSelect"></label>
				</div>
			</div>
		);
	};

	const isCheckboxChecked = (item) => {
		return selectedIds?.find((value) => parseInt(value.id) === parseInt(item.id));
	};

	const onCheckBoxClick = (e, value) => {
		if (e.target.checked) {
			setSelectedIds((prevState) => [...prevState, value]);
		} else {
			let ids = selectedIds.filter((item) => parseInt(item.id) !== parseInt(value.id));
			setSelectedIds(ids);
		}
	};

	const renderCheckBox = (product) => {
		return cardType !== 'DEVELOPMENT' ? (
			<div className="custom-chekbox d-inline-block align-middle">
				<div className="form-group m-0">
					<input
						type="checkbox"
						id={`sample_checkbox${product?.id}`}
						name="Company"
						// disabled={product.status === 'DELIVERED'}
						value={product?.id}
						checked={isCheckboxChecked(product)}
						onChange={(e) => onCheckBoxClick(e, product)}
					/>
					<label htmlFor={`sample_checkbox${product?.id}`} />
				</div>
			</div>
		) : (
			// checkAnyUserType(permittedUsersRole) && (
			<div className={'custom-chekbox d-inline-block align-middle'}>
				<div className="form-group m-0">
					<input
						type="checkbox"
						id={`sample_checkbox${product?.productId}`}
						name="Company"
						value={product?.productId}
						checked={selectedDesignIdsOfParent?.includes(product.productId)}
						onChange={(e) => {
							handleCheckboxOfParent(e, product.productId);
						}}
					/>
					<label htmlFor={`sample_checkbox${product?.productId}`} />
				</div>
			</div>
		);
	};

	const getRowSpan = (item) =>
		(item?.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT &&
			item?.setMemberSampleRequestItemResponseList?.length) ||
		1;

	const onCollspseFilter = () => setIsShowFilter(!isShowFilter);
	const isDisabledSelect = ['BD-Inhouse', 'Turkey-Inhouse']?.includes(selectedRow?.unitResponse?.name);

	const filterCountryUnits = (unitName) => {
		let countryPrefix = unitName?.trim('-')[0];
		return countryList.filter((item) => item.value.startsWith(countryPrefix));
	};

	return (
		<>
			<div
				className={`${
					cardType === 'SAMPLE_VIEW'
						? 'top-header transparent-filter'
						: 'top-header transparent-filter on-collection-development'
				}`}
			>
				<div className="filter-container-top p-0 bg-gray px-4 pt-2">
					<div className="sample-request-group-header border-0 pt-0">
						<div className="d-flex justify-content-between align-items-center">
							{cardType === 'SAMPLE_VIEW' && sample && (
								<>
									<ul className="common-list-component">
										<li>
											<img
												src={`${process.env.PUBLIC_URL}/icons/back-arrow-gray.svg`}
												alt="back"
												onClick={() => navigate(-1)}
												className="cursor-pointer mr-2"
											/>
											<span className="semibold-14 ml-2">
												{sample?.title || sample?.collectionName}
											</span>
											<span className="regular-12 gray_dark_02 weight-400">
												({sample?.refNo})
											</span>
										</li>

										<li>
											<span className="gray_dark_01">{sample?.requestedBy} </span>
										</li>
										<li>
											<span>
												{changeDateFormat(
													sample?.requestedDate,
													'YYYY-MM-DD',
													'Do MMM, YY'
												)}
											</span>
										</li>
										<li>
											<span>{checkSingular('Design', sample?.noOfDesign)} </span>
										</li>
										<li>
											<span className="brand-common-design">{sample?.brand}</span>
										</li>
									</ul>
								</>
							)}
						</div>
					</div>
					{cardType === 'SAMPLE_VIEW' && (
						<div className="top-up">
							<AddMemberToSample sampleId={id} />
						</div>
					)}
				</div>
				<SampleDetailsTopHeader
					toggleFilter={onCollspseFilter}
					setDefaultViewType={setDefaultViewType}
					elementRef={elementRef}
					defaultViewType={defaultViewType}
					cardType={cardType}
				/>
			</div>

			<section
				className={`${
					cardType === 'SAMPLE_VIEW'
						? 'filter-data-container filter-v3-data-container'
						: 'filter-data-container filter-v3-data-container on-collection-development'
				}`}
			>
				<FilterComponent
					filterPageName={allFilterPages.SAMPLE_DETAILS}
					fields={sampleDetailsFilterFields}
					showFilter={isShowFilter}
					isDependentFilter={true}
				/>
				<div className="data-table w-100 overflow-hidden">
					<div className="sample-request-gorup mt-0">
						{cardType !== 'DEVELOPMENT' && sample && (
							<>
								{(sample?.description?.length > 0 ||
									sample?.requestedDocumentList?.length > 0) && (
									<TopDetails
										type={'SAMPLE'}
										description={sample?.description}
										documentLists={sample?.requestedDocumentList}
									/>
								)}
							</>
						)}
						{sample?.sampleRequestItemResponseList?.length === 0 && !isLoading && (
							<NoData message="No request found" />
						)}
						{sample?.sampleRequestItemResponseList?.length > 0 && (
							<div className="sample-details-view-table">
								{(cardType === 'DEVELOPMENT' ||
									(cardType === 'SAMPLE_VIEW' &&
										defaultViewType === LIST_VIEW_TYPE.LIST_VIEW)) && (
									<table
										className="table with-border no-hover scroll-x-label scroll-y-label"
										ref={elementRef}
									>
										<thead>
											<tr>
												{((cardType === 'DEVELOPMENT' &&
													checkPrimaryUserType('FASHION_DESIGNER')) ||
													(cardType === 'SAMPLE_VIEW' &&
														!checkPrimaryUserType('FASHION_DESIGNER'))) && (
													<th className="select-box-column">
														{renderAllCheckBox()}
													</th>
												)}
												<th>
													Design (
													{sample?.sampleRequestItemResponseList?.length || 0})
												</th>
												<th>Material</th>
												<th className="text-nowrap">Fabric color, size &amp; qty</th>
												<th>Development</th>
												<th>Submission Plan Date</th>
												<th className="text-nowrap">Required Date</th>
												<th className="text-nowrap">Status & date</th>
												<th>Notes</th>
												<th>Conversation</th>
											</tr>
										</thead>
										<tbody>
											{sample?.sampleRequestItemResponseList?.map((item) => {
												return (
													<React.Fragment key={item?.productId}>
														<tr
															className={
																item.id && selectedSampleItemId == item.id
																	? 'highlight-table-row'
																	: ''
															}
														>
															{((cardType === 'DEVELOPMENT' &&
																checkPrimaryUserType('FASHION_DESIGNER')) ||
																(cardType === 'SAMPLE_VIEW' &&
																	!checkPrimaryUserType(
																		'FASHION_DESIGNER'
																	))) && (
																<td
																	rowSpan={getRowSpan(item)}
																	className={
																		isCheckboxChecked(item)
																			? 'checked select-box-column'
																			: 'select-box-column'
																	}
																>
																	{renderCheckBox(item)}
																</td>
															)}

															{/* design column */}
															<td
																rowSpan={getRowSpan(item)}
																className={`${
																	cardType === 'DEVELOPMENT' &&
																	selectedDesignIdsOfParent?.includes(
																		item.productId
																	)
																		? 'checked'
																		: ''
																} cursor-pointer design-column`}
															>
																<div
																	onClick={() =>
																		openDesignViewModal(
																			item,
																			item?.productId
																		)
																	}
																	data-toggle="modal"
																	data-target="#designViewModal"
																	className="sample-details-with-image d-flex align-items-center"
																>
																	{item.setPackStyleFlag ===
																	STATIC_SET_CONSTANTS.SET_PRODUCT ? (
																		<div
																			className="set-image-layout"
																			style={{ width: ' 68px' }}
																		>
																			<img
																				src={
																					item
																						?.setMemberSampleRequestItemResponseList?.[0]
																						?.featureImageDocUrl
																				}
																				alt="image"
																				className="cell-img pr-2"
																			/>
																			<img
																				src={
																					item
																						?.setMemberSampleRequestItemResponseList[1]
																						?.featureImageDocUrl
																				}
																				alt="image"
																				className="cell-img pr-2"
																			/>
																		</div>
																	) : (
																		<img
																			src={item?.featureImageDocUrl}
																			alt="image"
																			className="cell-img pr-2"
																		/>
																	)}
																	{item.setPackStyleFlag ===
																		STATIC_SET_CONSTANTS.SET_PRODUCT &&
																	item
																		?.setMemberSampleRequestItemResponseList[0]
																		? renderDesignDetails(
																				item
																					?.setMemberSampleRequestItemResponseList[0],
																				item.setPackStyleFlag ===
																					STATIC_SET_CONSTANTS.SET_PRODUCT,
																				item?.setMemberSampleRequestItemResponseList
																			)
																		: renderDesignDetails(
																				item,
																				false,
																				[],
																				item.setPackStyleFlag ===
																					STATIC_SET_CONSTANTS.PACK_PRODUCT
																			)}
																</div>
															</td>

															{/* meterial column */}
															<td className="materials-list-column">
																{item.setPackStyleFlag ===
																STATIC_SET_CONSTANTS.SET_PRODUCT
																	? renderMaterialsList(
																			item
																				?.setMemberSampleRequestItemResponseList[0]
																				?.materialList
																		)
																	: renderMaterialsList(
																			item.materialList &&
																				item.materialList
																		)}
															</td>
															{/* Fabric, color, size & qty Column */}
															<td className="color-qty-column">
																<div className="sample-details">
																	{item.setPackStyleFlag ===
																	STATIC_SET_CONSTANTS.SET_PRODUCT
																		? item?.setMemberSampleRequestItemResponseList[0]?.sampleItemDetailsResponseList?.map(
																				(size) =>
																					renderFabricColorAndSizeColumn(
																						size
																					)
																			)
																		: item?.sampleItemDetailsResponseList?.map(
																				(size) =>
																					renderFabricColorAndSizeColumn(
																						size
																					)
																			)}
																</div>
															</td>
															{/* development column */}
															<td
																rowSpan={getRowSpan(item)}
																className="development-column"
															>
																{((cardType === 'DEVELOPMENT' && item?.id) ||
																	cardType === 'SAMPLE_VIEW') && (
																	<div>
																		{renderDevelopmentDetails(item)}
																	</div>
																)}
															</td>

															<td rowSpan={getRowSpan(item)}>
																{((cardType === 'DEVELOPMENT' && item?.id) ||
																	cardType === 'SAMPLE_VIEW') && (
																	<input
																		type="date"
																		name="submission-date"
																		value={item?.submissionPlanDate}
																		onChange={(e) =>
																			onChangeSubmissionDate(e, item)
																		}
																		onClick={() => setSelectedRow(item)}
																		disabled={
																			cardType === 'DEVELOPMENT' &&
																			!checkPrimaryUserType(
																				'FASHION_DESIGNER'
																			)
																		}
																	/>
																)}
															</td>
															<td rowSpan={getRowSpan(item)}>
																<div>
																	{changeDateFormat(
																		item?.requireDate,
																		'',
																		'Do MMM, YYYY'
																	)}
																</div>
															</td>

															{/* Status Column  */}
															<td
																rowSpan={getRowSpan(item)}
																className="status-column cursor-pointer"
																onClick={(e) => {
																	e?.stopPropagation();
																	setShowSampleTimelineId(item.id);
																}}
															>
																{renderSatusColumn(item)}
															</td>

															{/* Notes column */}
															<td
																onClick={() =>
																	item.id && setActiveRemarksId(item.id)
																}
																rowSpan={getRowSpan(item)}
															>
																<SampleInlineComment
																	sampleRequestId={sample.id || 0}
																	id={item.id}
																	remarks={item?.remarks}
																	activeRemarksId={activeRemarksId}
																	onReset={() => {
																		setActiveRemarksId(null);
																	}}
																	isSet={
																		item.setPackStyleFlag ===
																		STATIC_SET_CONSTANTS.SET_PRODUCT
																	}
																	setmembers={
																		item?.setMemberSampleRequestItemResponseList
																	}
																	cardType={cardType}
																/>
															</td>
															{/* conversation column */}
															<td rowSpan={getRowSpan(item)}>
																<div className="conversation-btn">
																	<button
																		className="button text"
																		onClick={() => {
																			dispatch(
																				setCurrentActivePage({
																					id: item?.productId,
																					type: 'PRODUCT_CONVERSATION',
																					pageType: 'DETAILS'
																				})
																			);
																			setSelectedId(item?.productId);
																			setShowComment(true);
																		}}
																	>
																		{item?.noOfUnreadMessage > 0 ? (
																			<img
																				src={`${process.env.PUBLIC_URL}/icons/comment-not-read.svg`}
																				alt="not read"
																			/>
																		) : (
																			<img
																				src={`${process.env.PUBLIC_URL}/icons/comments-gray.svg`}
																				alt="not read"
																			/>
																		)}
																	</button>
																</div>
															</td>
														</tr>
														{item.setPackStyleFlag ===
															STATIC_SET_CONSTANTS.SET_PRODUCT &&
															renderSetItemRow(
																item?.setMemberSampleRequestItemResponseList,
																item.id
															)}
													</React.Fragment>
												);
											})}
										</tbody>
									</table>
								)}

								{cardType === 'DEVELOPMENT' ||
									(cardType === 'SAMPLE_VIEW' &&
										defaultViewType !== LIST_VIEW_TYPE.LIST_VIEW && (
											<SampleDesignCard
												sampleList={sample?.sampleRequestItemResponseList}
												sampleInfo={sample}
												selectedIds={selectedIds}
												setSelectedIds={setSelectedIds}
												openDesignViewModal={openDesignViewModal}
												isCheckboxChecked={isCheckboxChecked}
											/>
										))}
							</div>
						)}

						{selectedId && (
							<SampleComment
								sampleRequestId={sampleRequestId}
								postTypeFilter={'PRODUCT_DEVELOPMENT_COMMENT'}
								topic={'PRODUCT_SAMPLE_COMMENT'}
								postTypeId={'sampleRequestId'}
								productId={selectedId}
								showComment={showComment}
								setShowComment={handleCommentClose}
								brandInfo={{
									brandId: sample?.brandId,
									brandName: sample?.brand
								}}
							/>
						)}

						{selectedIds?.length > 0 && (
							<SampleActionPopup
								selectedIds={selectedIds}
								closeModal={() => setSelectedIds([])}
							/>
						)}
						{isUpdateClick && (
							<ModalContainer className="width-784-dialog development-info-modal">
								<div className="common-popup shadow-24dp">
									<div className="common-popup-header d-flex justify-content-between">
										<div className="popup-tilte">
											<h3 className="semibold-16 mb-0">Development Info</h3>
										</div>
										<div
											className="close-btn"
											onClick={() => {
												setSelectedRow(null);
												setIsUpdateClick(false);
											}}
										>
											<img
												src={`${process.env.PUBLIC_URL}/icons/close.svg`}
												alt="close"
											/>
										</div>
									</div>
									<div className="common-popup-body">
										<table className="table with-border no-hover">
											<thead>
												<tr>
													<th>Country In-house/Factory</th>
													<th>Development Factory</th>
													<th>Fabric Supplier</th>
												</tr>
											</thead>

											<tbody>
												<tr>
													<td>
														<div className="transparent-select">
															<CustomDropdown
																type="addItem"
																title={'Country'}
																onItemClick={(obj) =>
																	handleDropDown(obj, 'unitResponse')
																}
																items={filterCountryUnits(
																	selectedRow?.unitResponse?.name
																)}
																selectedItem={selectedRow?.unitResponse?.name}
																toolTipLength={25}
															/>
														</div>
													</td>
													<td className={`${isDisabledSelect ? 'disabled' : ''}`}>
														<div className="transparent-select">
															<CustomDropdown
																onItemSearch={(searchTerm) =>
																	onFetchSupplierList(searchTerm)
																}
																onItemClick={(obj) =>
																	handleDropDown(obj, 'developmentFactory')
																}
																items={supplierList}
																selectedItem={
																	selectedRow?.developmentFactory?.name
																}
																toolTipLength={25}
																isDisabled={isDisabledSelect}
															/>
														</div>
													</td>
													<td className={`${isDisabledSelect ? 'disabled' : ''}`}>
														<div className="transparent-select">
															<CustomDropdown
																title={'Select'}
																onItemSearch={(searchTerm) =>
																	onFetchSupplierList(searchTerm)
																}
																onItemClick={(obj) =>
																	handleDropDown(obj, 'fabricSupplier')
																}
																items={supplierList}
																selectedItem={
																	selectedRow?.fabricSupplier?.name
																}
																toolTipLength={25}
																isDisabled={isDisabledSelect}
															/>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div className="modal-footer">
										<div className="footer-buttons text-right">
											<button
												className="button gray-outline size32"
												onClick={() => {
													setSelectedRow(null);
													setIsUpdateClick(false);
												}}
											>
												Cancel
											</button>
											<button
												className="button size32 ml-2"
												disabled={isLoading}
												onClick={() => handleSubmit(selectedRow)}
											>
												Update
											</button>
										</div>
									</div>
								</div>
							</ModalContainer>
						)}
					</div>{' '}
				</div>
			</section>
		</>
	);
};

export default SampleRequestCard;
